import { useCallback, useState } from "react";

import { handleToast } from "../../../utils/functions";

import client from "../../client";
import handleApiError from "../../../hooks/handleApiError";

export default function useCreateAttendanceSheet() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (classId, payload) => {
    try {
      setLoading(true);

      const res = await client.post(
        `/attendance/class/${classId}/new`,
        payload
      );

      handleToast(res.data?.message);
      setLoading(false);
      return true;
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return { request, loading };
}
